import * as yup from "yup";

const laboratorySchema = yup.object({
  name: yup.string().required(),
});

export type LaboratoryBase = yup.InferType<typeof laboratorySchema>;

export default laboratorySchema;
